import {
  appConfig,
  Auth,
  saveAuthToLocalStorage,
} from "@micad/vue-components/src/repos/login";
import { AppConfig, initLogin } from "@micad/vue-components";
import config from "@/config";
import { getUserSession, UserSessionResponse } from "@/data/repos/userInfo";
import { reactive } from "@vue/composition-api";

export const userInfo: UserSessionResponse = {} as UserSessionResponse;
export const authzFlags = reactive<string[]>([]);
const roleMap: { [key: string]: { [key: string]: string } } = {
  MicadAdmin: {
    MicadFlags: "rw",
    Branding: "rw",
    Clients: "rw",
    Connections: "rw",
    Licences: "rw",
    Notifications: "rw",
    Terms: "rw",
    Users: "rw",
    UserProfiles: "rw",
  },
  Admin: {
    Branding: "rw",
    Connections: "rw",
    Notifications: "rw",
    Terms: "rw",
    Users: "rw",
  },
  User: {
    Users: "rw",
  },
  Viewer: {
    Users: "r",
  },
  None: {},
};

export async function fetchUserInfo() {
  const resp = (await getUserSession()).payload;
  Object.assign(userInfo, resp);
  const myRole = userInfo.micadUser
    ? "MicadAdmin"
    : userInfo.appRoles
    ? userInfo.appRoles["Accounts"]
    : "None";
  if (Object.keys(roleMap).includes(myRole)) {
    Object.entries(roleMap[myRole]).forEach(([k, v]) =>
      authzFlags.push(`${k}_${v}`)
    );
  }
  return userInfo;
}
export const canIUse = (item: string): boolean =>
  authzFlags.reduce(
    (ret: boolean, v: string) => v.startsWith(item) || ret,
    false
  );

export function SaveAuth(a: Auth) {
  saveAuthToLocalStorage(a);
  initLogin({
    AUTH_URL: config.AUTH_URL,
    BASE_URL: config.BASE_URL,
    AUTH_CALLBACK_URL: config.AUTH_CALLBACK_URL,
  } as AppConfig);
}
export function getDayEnd() {
  const bestBefore = new Date();
  bestBefore.setUTCHours(23, 59, 59, 999);
  return bestBefore;
}

export function loginRedirect(query: any) {
  let authURL = appConfig.AUTH_URL;
  authURL = authURL.replace("AUTH_CALLBACK_URL", query.callbackUrl);
  authURL = authURL.replace("PAGE_RETURN_URL", query.returnUrl);
  console.log("Redirecting to ", authURL);
  window.location.href = authURL;
}
